import styled from "styled-components";

export const TabPanelInner: any = styled('div')`
  && {
    height: auto;
    overflow-y: auto;
  }
`;
